import React, { useEffect } from 'react'

function IC_referralCode( { data, dataId, setDataKeyValue } ) {
  
    useEffect( () => {
        setDataKeyValue('code' , data?.code?.toUpperCase().replace(/[^A-Z0-9?!]+/g , '-'))
    },[data.code])
  
    return 
}

export default IC_referralCode